import {Outlet, useMatch} from "react-router";
import ManagementWorkspace from "@/components/management/ManagementWorkspace.tsx";
import SceneListPanel from "@/scenes/SceneListPanel.tsx";

export default function SceneWorkspace() {
    const createMatch = useMatch("/campaigns/:campaignSlug/scenes/new");
    const detailMatch = useMatch("/campaigns/:campaignSlug/scenes/:id");
    const editMatch = useMatch("/campaigns/:campaignSlug/scenes/:id/edit");
    const selectedId = createMatch ? undefined : editMatch?.params.id ?? detailMatch?.params.id;

    return (
        <ManagementWorkspace sidebar={<SceneListPanel selectedId={selectedId}/>}>
            <Outlet/>
        </ManagementWorkspace>
    );
}
